// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"3b9f3347","423":"2df19245","714":"b9c9cc7d","770":"de41d58e","771":"44132adc","776":"32ee9a4d"}[chunkId] + ".chunk.css";
};